import {computed} from "@preact/signals-react";
import {appConfig} from "./app";


export const navWidth = computed(() => appConfig.value?.menu?.nav?.width?.extended || 0)
export const navWidthMini = computed(() => appConfig.value?.menu?.nav?.width?.mini || 0)
export const navHeightItem = computed(() => appConfig.value?.menu?.nav?.height?.item || 0)
export const navHeightItemSub = computed(() => appConfig.value?.menu?.nav?.height?.subItem || 0)